/*
 *
 * SecuritySetUp action/reducer
 *
 */

import { PayloadAction, createAction, createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { mfaFlow } from "utils/enum";
import { createActionDispatchers } from "utils/reduxHelpers";
import { clearGlobalUserInfo } from "scenes/redux";
import { SecurityMethodTypes } from "./types";

export type State = {
  loading: boolean;
  showError: boolean;
  securityMethods: Array<SecurityMethodTypes>;
  hasSuccessMsgSeen: boolean;
};

export const initialState: State = {
  loading: false,
  showError: false,
  securityMethods: [],
  hasSuccessMsgSeen: false,
};

const slice = createSlice({
  name: "securitySetUp",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    setError(state: State, action: PayloadAction<boolean>) {
      state.showError = action.payload;
    },
    loadSecurityMethods(state: State) {
      state.loading = true;
    },
    afterSecurityMethodFetch(
      state: State,
      action: PayloadAction<Array<SecurityMethodTypes>>
    ) {
      state.loading = false;
      state.securityMethods = action.payload;
    },
    setSuccessMsgBoolean(state: State, action: PayloadAction<boolean>) {
      state.hasSuccessMsgSeen = action.payload;
    },
  },
  // reducer for external action
  // extraReducers: (builder) => {
  // builder.addCase(externalAction, (state) => {
  // });
  // },
});

/**
 * create actions WITHOUT reducer (pure action) here
 */
export const pureAction = createAction("securitySetUp/pureAction");

/**
 * actions from slice to be exported for saga
 */
export const {
  setError,
  loadSecurityMethods,
  afterSecurityMethodFetch,
  setSuccessMsgBoolean,
} = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  ["setError", "loadSecurityMethods"],
  // pure actions
  {
    pureAction,
    goToOktaVerifyScreen: () =>
      push("/okta-verify", {
        navigationFrom: "/security",
        currentLayout: mfaFlow.SECURITY,
      }),
    goToAppAuthenticatorScreen: () =>
      push("/env-auth-verify", {
        navigationFrom: "/security",
        currentLayout: mfaFlow.SECURITY,
      }),
    goToAppPhoneScreen: () =>
      push("/phone", {
        navigationFrom: "/security",
        currentLayout: mfaFlow.SECURITY,
      }),
    goToEnvAppScreen: () =>
      push("/env-auth-verify", {
        navigationFrom: "/security",
        currentLayout: mfaFlow.SECURITY,
      }),
    goToEmailOtpScreen: () =>
      push("/email-otp", {
        navigationFrom: "/security",
        currentLayout: mfaFlow.SECURITY,
      }),
    clearGlobalUserInfo,
    goToLoginScreen: () => push("/"),
    setSuccessMsgBoolean,
  }
);

export default slice.reducer;
